(function () {
  function initComparison(section) {
    if (section.dataset.pcInitialized === 'true') {
      return;
    }

    section.dataset.pcInitialized = 'true';

    var productSelect = section.querySelector('[data-pc-product-select]');
    var productButton = section.querySelector('[data-pc-product-button]');
    var selectedProduct = section.querySelector('[data-pc-selected-product]');
    var selectedProductHeader = section.querySelector('[data-pc-selected-product-header]');
    var productOptions = section.querySelectorAll('[data-pc-vendor-option]');
    var vendorDataScript = document.querySelector('[data-pc-vendor-data][data-section-id="' + section.id + '"]');
    var statusRegion = section.querySelector('[data-pc-status]');
    var categoryButtons = section.querySelectorAll('[data-pc-filter]');
    var groups = section.querySelectorAll('[data-pc-group]');
    var nuanceButtons = section.querySelectorAll('[data-pc-nuance-toggle]');
    var vendorData = {};

    if (vendorDataScript) {
      try {
        vendorData = JSON.parse(vendorDataScript.textContent);
      } catch (error) {
        vendorData = {};
      }
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formattedValue(value) {
      return escapeHtml(value || '').replace(/\n/g, '<br>');
    }

    function closeProductSelect(restoreFocus) {
      if (!productSelect || !productButton) {
        return;
      }

      productSelect.classList.remove('is-open');
      productButton.setAttribute('aria-expanded', 'false');

      if (restoreFocus) {
        productButton.focus();
      }
    }

    function applyStatus(element, status) {
      element.classList.remove('prenatal-comparison__value--warning', 'prenatal-comparison__value--danger');

      var previousLabel = element.querySelector('.visually-hidden');

      if (previousLabel) {
        previousLabel.remove();
      }

      var statusLabel = 'Meets standard: ';

      if (status === 'warning') {
        element.classList.add('prenatal-comparison__value--warning');
        statusLabel = 'Partially fulfills standards: ';
      }

      if (status === 'danger') {
        element.classList.add('prenatal-comparison__value--danger');
        statusLabel = 'Does not meet standard: ';
      }

      var srLabel = document.createElement('span');
      srLabel.className = 'visually-hidden';
      srLabel.textContent = statusLabel;
      element.insertBefore(srLabel, element.firstChild);
    }

    function selectVendor(vendorKey, restoreFocus) {
      var vendor = vendorData[vendorKey];

      if (!vendor) {
        return;
      }

      section.dataset.pcSelectedVendor = vendorKey;

      if (selectedProduct) {
        selectedProduct.textContent = vendor.name;
      }

      if (selectedProductHeader) {
        selectedProductHeader.setAttribute('aria-label', vendor.name);
      }

      if (productButton) {
        productButton.setAttribute('aria-label', 'Change competitor, currently ' + vendor.name);
      }

      if (statusRegion) {
        statusRegion.textContent = 'Comparing Fullwell with ' + vendor.name;
      }

      section.querySelectorAll('[data-pc-competitor-value]').forEach(function (element) {
        var rowKey = element.getAttribute('data-pc-competitor-value');
        var rowData = vendor.values && vendor.values[rowKey];

        if (!rowData) {
          return;
        }

        element.innerHTML = formattedValue(rowData.value);
        applyStatus(element, rowData.status);
      });

      productOptions.forEach(function (option) {
        var isSelected = option.getAttribute('data-pc-vendor-option') === vendorKey;
        option.hidden = isSelected;
        option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      closeProductSelect(restoreFocus);
    }

    if (productSelect && productButton) {
      productButton.addEventListener('click', function () {
        var isOpen = productSelect.classList.toggle('is-open');
        productButton.setAttribute('aria-expanded', String(isOpen));
      });

      productSelect.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !productSelect.classList.contains('is-open')) {
          return;
        }

        event.preventDefault();
        closeProductSelect(true);
      });
    }

    productOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        selectVendor(option.getAttribute('data-pc-vendor-option'), true);
      });
    });

    selectVendor(section.dataset.pcSelectedVendor || 'care', false);

    function setCategoryTabstop(activeButton) {
      categoryButtons.forEach(function (item) {
        item.setAttribute('tabindex', item === activeButton ? '0' : '-1');
      });
    }

    function applyFilter(button) {
      var filter = button.getAttribute('data-pc-filter');

      categoryButtons.forEach(function (item) {
        var isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });

      setCategoryTabstop(button);

      groups.forEach(function (group) {
        var groupName = group.getAttribute('data-pc-group');
        group.hidden = filter !== 'all' && groupName !== filter;
      });
    }

    categoryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        applyFilter(button);
      });

      button.addEventListener('keydown', function (event) {
        var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];

        if (keys.indexOf(event.key) === -1) {
          return;
        }

        event.preventDefault();

        var buttons = Array.prototype.slice.call(categoryButtons);
        var index = buttons.indexOf(button);
        var nextIndex = index;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % buttons.length;
        }

        if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + buttons.length) % buttons.length;
        }

        if (event.key === 'Home') {
          nextIndex = 0;
        }

        if (event.key === 'End') {
          nextIndex = buttons.length - 1;
        }

        setCategoryTabstop(buttons[nextIndex]);
        buttons[nextIndex].focus();
      });
    });

    nuanceButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var row = button.closest('[data-pc-row]');

        if (!row) {
          return;
        }

        var isOpen = row.classList.toggle('is-open');
        var nuanceId = button.getAttribute('aria-controls');
        var nuance = nuanceId ? document.getElementById(nuanceId) : null;

        button.setAttribute('aria-expanded', String(isOpen));

        if (nuance) {
          nuance.hidden = !isOpen;

          if (isOpen) {
            window.requestAnimationFrame(function () {
              nuance.focus({ preventScroll: true });
            });
          }
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!productSelect || productSelect.contains(event.target)) {
        return;
      }

      closeProductSelect(false);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-prenatal-comparison]').forEach(initComparison);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.matches('[data-prenatal-comparison]')) {
      initComparison(event.target);
    }
  });
})();
